import type { TenantUserDto } from './models';
import { RestService } from '@abp/ng.core';
import type { ListResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TenantUserLookupService {
  apiName = 'Default';
  

  getTenantUserLookup = () =>
    this.restService.request<any, ListResultDto<TenantUserDto>>({
      method: 'GET',
      url: '/api/app/tenant-user-lookup/tenant-user-lookup',
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
